import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'

import content from '../../../../public/assets/markdown/privacy-policy.md'

export const Privacy = () => {
  return <MarkdownContentRenderer content={content} />
}
